<script lang='ts'>
import { defineComponent } from '@vue/composition-api';

const InsightMenuIcon = defineComponent({
    name: 'InsightMenuIcon',
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
});

export default InsightMenuIcon;
</script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6464 13.674L16.4548 8.86565M11.8877 14.1332L6.78946 9.035M11.5 14V1M21.5 14.5H19.5C18.9477 14.5 18.5 14.9477 18.5 15.5V16.5C18.5 17.0523 18.0523 17.5 17.5 17.5H6.5C5.94772 17.5 5.5 17.0523 5.5 16.5V15.5C5.5 14.9477 5.05228 14.5 4.5 14.5H2.5C1.94772 14.5 1.5 14.9477 1.5 15.5V21.5C1.5 22.0523 1.94772 22.5 2.5 22.5H21.5C22.0523 22.5 22.5 22.0523 22.5 21.5V15.5C22.5 14.9477 22.0523 14.5 21.5 14.5Z"
      fill="transparent"
      stroke="currentColor"
      style="fill: transparent !important;"
    />
  </svg> 
</template>

<style lang='scss' scoped></style>